<template>
  <div></div>
</template>
<script>
import { BarcodeDetector } from 'barcode-detector';

export default defineComponent({
  mounted() {
    window.BarcodeDetector = BarcodeDetector;
  },
});
</script>
